import React, { forwardRef } from 'react';
import MaskedInput from 'react-text-mask';
const TextMaskCustom = forwardRef((props, ref) => (
  <MaskedInput
    {...props}
    ref={ref}
    mask={[
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ]}
    placeholderChar={'\u2000'}
    showMask
    guide={false}
  />
));

export default TextMaskCustom;
